/**
 * Generates a suffix for id and data-insights attributes.
 *
 * ```tsx
 * const id = useUniqueId(prefixId, defaultId);
 * const idAttrs = useIdAttrs({ id, insightsAttr });
 *
 * return (
 *   <div {...idAttrs()}>
 *     <div {...idAttrs("-inner")} />
 *   </div>
 * );
 * ```
 */
const useIdAttrs = ({ id, insightsAttr: insights }) => (suffix = "", options = {}) => {
    const { insights: insightsSuffix = suffix, prepend = false } = options;
    const idAttr = prepend ? `${suffix}${id}` : `${id}${suffix}`;
    const insightsAttr = insights && (prepend ? `${insightsSuffix}${insights}` : `${insights}${insightsSuffix}`);
    return { id: idAttr, "data-insights": insightsAttr };
};
export default useIdAttrs;
//# sourceMappingURL=useIdAttrs.js.map